module.exports = __webpack_public_path__ + "img/file.605c8071.svg";